import { InvoiceMinDto, InvoiceStatusType } from 'types/invoices';

/**
 * Picks the latest connected invoice (by invoiceDate descending, tie-broken by id descending) and
 * returns its paid-on date only when that invoice is in PAID status and the date is set. Returns
 * null otherwise, so callers can conditionally render the paid date beneath the invoice links.
 */
export const getLatestConnectedInvoicePaidDate = (invoices: InvoiceMinDto[]): string | null => {
    if (invoices.length === 0) {
        return null;
    }

    const latest = [...invoices].sort((a, b) => {
        if (a.invoiceDate !== b.invoiceDate) {
            return a.invoiceDate < b.invoiceDate ? 1 : -1;
        }
        return b.id - a.id;
    })[0];

    if (latest.invoiceStatusTypeCode === InvoiceStatusType.PAID && latest.paidOnDate) {
        return latest.paidOnDate;
    }

    return null;
};
